import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_INFO } from '../data/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#233424] text-[#EFEBE4] pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 pb-12 border-b border-[#354836]">
          {/* Col 1: Brand & Logo */}
          <div className="space-y-4">
            <Link to="/" className="inline-block group" aria-label="KerneViden - Til forsiden">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=400,format=auto/assets/1d30bca3-a748-4ede-8335-828014d68a29/logo.png"
                alt="KerneViden Logo"
                className="h-16 sm:h-20 md:h-24 w-auto max-w-[240px] object-contain brightness-0 invert opacity-95 transition-transform duration-200 group-hover:scale-105"
              />
            </Link>
            <p className="text-xs text-[#B2C2B0] leading-relaxed max-w-xs">
              Et trygt, fleksibelt og nærværende rum for unge, voksne og pårørende.
            </p>
          </div>

          {/* Col 2: Navigation Links */}
          <div>
            <h3 className="text-xs font-semibold text-white tracking-widest uppercase mb-4">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Hjem
                </Link>
              </li>
              <li>
                <Link to="/vores-tjenester" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Forløb &amp; Ydelser
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Om KerneViden
                </Link>
              </li>
              <li>
                <Link to="/blogindlaeg" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Blogindlæg &amp; Artikler
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Kontakt mig
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Forløb links */}
          <div>
            <h3 className="text-xs font-semibold text-white tracking-widest uppercase mb-4">
              Forløb
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/vores-tjenester" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Ungeforløb
                </Link>
              </li>
              <li>
                <Link to="/vores-tjenester" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Voksenforløb
                </Link>
              </li>
              <li>
                <Link to="/vores-tjenester" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Selvforståelsesforløb Autisme/ADHD
                </Link>
              </li>
              <li>
                <Link to="/vores-tjenester" className="text-[#BFCFBE] hover:text-white transition-colors">
                  Forældreforløb og rådgivning
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Virksomhedsoplysninger */}
          <div>
            <h3 className="text-xs font-semibold text-white tracking-widest uppercase mb-4">
              Virksomhedsoplysninger
            </h3>
            <ul className="space-y-3 text-sm text-[#BFCFBE]">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot mt-1 text-white" aria-hidden="true" />
                <span>
                  {SITE_INFO.name}<br />
                  {SITE_INFO.address}<br />
                  {SITE_INFO.zipCity}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-white" aria-hidden="true" />
                <a
                  href={`tel:${SITE_INFO.phone.replace(/\s+/g, '')}`}
                  className="hover:text-white transition-colors whitespace-nowrap font-medium text-white"
                >
                  <span className="whitespace-nowrap">{SITE_INFO.phoneFormatted}</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-white" aria-hidden="true" />
                <a
                  href={`mailto:${SITE_INFO.email}`}
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{SITE_INFO.email}</span>
                </a>
              </li>
              <li className="pt-2">
                <a
                  href={SITE_INFO.facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="KerneViden på Facebook"
                  className="inline-flex items-center justify-center text-white hover:text-white/80 transition-transform hover:scale-110 p-1"
                >
                  <i className="fa-brands fa-facebook-f text-white text-lg" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-[#8FA28D] gap-4">
          <p>© {currentYear} {SITE_INFO.name}. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1.5">
            <span>{SITE_INFO.address}, {SITE_INFO.zipCity}</span>
            <span aria-hidden="true">•</span>
            <span>CVR {SITE_INFO.cvr}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
